//export { NodeBGR } from "./NodeBGR";
//export { NodeBGYR } from "./NodeBGYR";
//export { NodeRoot } from "./NodeRoot";
import * as ConnectionsTypes from "./ConnectionsTypes";
import * as HandlesColors from "./HandlesColors";

export { NodeCaption } from "./NodeCaption";
export { NodeWrapper } from "./NodeWrapper";
export { NodeContent } from "./NodeContent";
export { NodeWindow } from "./NodeWindow";
export { HandleInput } from "./HandleInput";
export { HandleOutputGreen } from "./HandleOutputGreen";
export { HandleOutputRed } from "./HandleOutputRed";
export { HandleOutputYellow } from "./HandleOutputYellow";
export { HandleOutputPurple } from "./HandleOutputPurple";
export { HandleOutputWrapper } from "./HandleOutputWrapper";
export { handlesDefaultLabels } from "./HandlesLabels";


export const getConnectionType = (type, isConnectable) => (ConnectionsTypes[type] || ConnectionsTypes.B)(isConnectable);

export const getHandleColor = (type) => HandlesColors[type];
export const handlesColors = HandlesColors;